import DaechiSeatSvg from "../dashboard/components/etc/daechiseatsvg";
import GangnamSeatSvg from "../dashboard/components/etc/gangnamseatsvg";
import Daechi2SeatSvg from "../dashboard/components/etc/daechi2seatsvg";
import Daechi3SeatSvg from "../dashboard/components/etc/daechi3seatsvg";
import SongdoSeatSvg from "../dashboard/components/etc/songdoseat";
import { filter } from "lodash";
import SongdoFreeSeatSvg from "../dashboard/components/etc/songdofreeseatsvg3";
import SongdoFixedSeatSvg from "../dashboard/components/etc/songdofixedseatsvg2";
import SongdoFreeSeatSvg2 from "../dashboard/components/etc/songdofreeseatsvg2";
import MolipSeatSvg from "../dashboard/components/etc/molipseatsvg";
import BundangSeatSvg from "../dashboard/components/etc/bundangseat";
import SongpaSeatSvg from "../dashboard/components/etc/songpaseat";
import UbaseSeatSvg from "../dashboard/components/etc/ubaseseat";
import AllTargetSeat from "../dashboard/components/etc/alltargetseat";
import DaeguSeatSvg from "../dashboard/components/etc/daeguseatsvg";
import LionSeatSvg from "../dashboard/components/etc/lionseatsvg";
import AllTargetSeat2 from "../dashboard/components/etc/alltargetseat2";
import Gangnam2Seat from "../dashboard/components/etc/gangnam2seat";
import Songdo7thSeatSvg from "../dashboard/components/etc/songdo7thseatsvg";
import GimpoSeatSvg from "../dashboard/components/etc/gimposeat";
import SinchonSeatSvg from "../dashboard/components/etc/sinchonseat";
import GangdongSeatSvg from "../dashboard/components/etc/gangdongseat";
import SinchonSeatSvg2 from "../dashboard/components/etc/sinchonseat2";
import HanamSeat from "../dashboard/components/etc/hanamseat";
import DongtanSeatSvg from "../dashboard/components/etc/dongtanseatsvg";
import CentumSeatSvg from "../dashboard/components/etc/centumseatsvg";



export interface ClassInfo {
    classNumber: string;
    start: {
        hours: number;
        minutes: number;
    };
    end: {
        hours: number;
        minutes: number;
    };
    isFirst?: boolean;
    isLast?: boolean;
    isSaturedayLast?: boolean;
};

interface ClassInfos {
    one: ClassInfo[];
    two: ClassInfo[];
    three: ClassInfo[];
    four: ClassInfo[];
    five: ClassInfo[];
    six: ClassInfo[];
    seven: ClassInfo[];
    eight: ClassInfo[];
    nine: ClassInfo[];
    ten: ClassInfo[];
}

interface LocationData {
    academy: string[]
    korean: string,
    english: string,
    filterValue_contains?: string,
    jobs?: any[],
    seatSvg?: any,
    questionLocation?: any[],
    classInfo?: ClassInfo[],
    isFree?: boolean,
    needRegularMeal?: boolean,
    needOutside?: boolean,
    maxSeat?: number,
}

const classInfos: ClassInfos = {
    one: [
        {
            classNumber: "zero",
            start: {
                hours: 8,
                minutes: 0
            },
            end: {
                hours: 8,
                minutes: 45
            },
            isFirst: true
        },
        {
            classNumber: "first",
            start: {
                hours: 9,
                minutes: 0
            },
            end: {
                hours: 10,
                minutes: 15
            }
        },
        {
            classNumber: "second",
            start: {
                hours: 10,
                minutes: 30
            },
            end: {
                hours: 11,
                minutes: 45
            }
        },
        {
            classNumber: "third",
            start: {
                hours: 13,
                minutes: 0
            },
            end: {
                hours: 14,
                minutes: 15
            }
        },
        {
            classNumber: "fourth",
            start: {
                hours: 14,
                minutes: 30
            },
            end: {
                hours: 15,
                minutes: 45
            },
            isSaturedayLast: true
        },
        {
            classNumber: "fifth",
            start: {
                hours: 16,
                minutes: 0
            },
            end: {
                hours: 17,
                minutes: 15
            }
        },
        {
            classNumber: "sixth",
            start: {
                hours: 18,
                minutes: 30
            },
            end: {
                hours: 19,
                minutes: 30
            }

        },
        {
            classNumber: "seventh",
            start: {
                hours: 19,
                minutes: 45
            },
            end: {
                hours: 20,
                minutes: 45
            }

        },
        {
            classNumber: "eighth",
            start: {
                hours: 21,
                minutes: 0
            },
            end: {
                hours: 22,
                minutes: 0
            },
            isLast: true
        },
        {
            classNumber: "lunch",
            start: {
                hours: 11,
                minutes: 45
            },
            end: {
                hours: 13,
                minutes: 0
            }
        },
        {
            classNumber: "dinner",
            start: {
                hours: 17,
                minutes: 15
            },
            end: {
                hours: 18,
                minutes: 30
            }
        }
    ],
    two: [
        {
            classNumber: "first",
            start: {
                hours: 8,
                minutes: 0
            },
            end: {
                hours: 8,
                minutes: 50
            },
            isFirst: true
        },
        {
            classNumber: "second",
            start: {
                hours: 9,
                minutes: 0
            },
            end: {
                hours: 9,
                minutes: 50
            }
        },
        {
            classNumber: "third",
            start: {
                hours: 10,
                minutes: 0
            },
            end: {
                hours: 10,
                minutes: 50
            }
        },
        {
            classNumber: "fourth",
            start: {
                hours: 11,
                minutes: 0
            },
            end: {
                hours: 12,
                minutes: 0
            }

        },
        {
            classNumber: "fifth",
            start: {
                hours: 13,
                minutes: 0
            },
            end: {
                hours: 13,
                minutes: 50
            }
        },
        {
            classNumber: "sixth",
            start: {
                hours: 14,
                minutes: 0
            },
            end: {
                hours: 14,
                minutes: 50
            }

        },
        {
            classNumber: "seventh",
            start: {
                hours: 15,
                minutes: 0
            },
            end: {
                hours: 15,
                minutes: 50
            }

        },
        {
            classNumber: "eighth",
            start: {
                hours: 16,
                minutes: 0
            },
            end: {
                hours: 16,
                minutes: 50
            }
        },
        {
            classNumber: "ninth",
            start: {
                hours: 17,
                minutes: 0
            },
            end: {
                hours: 17,
                minutes: 50
            }
        },
        {
            classNumber: "tenth",
            start: {
                hours: 19,
                minutes: 0
            },
            end: {
                hours: 19,
                minutes: 50
            }
        },
        {
            classNumber: "eleventh",
            start: {
                hours: 20,
                minutes: 0
            },
            end: {
                hours: 20,
                minutes: 50
            }
        },
        {
            classNumber: "twelfth",
            start: {
                hours: 21,
                minutes: 0
            },
            end: {
                hours: 21,
                minutes: 50
            },
            isSaturedayLast: true
        },
        {
            classNumber: "thirteenth",
            start: {
                hours: 22,
                minutes: 0
            },
            end: {
                hours: 22,
                minutes: 50
            }
        },
        {
            classNumber: "fourteenth",
            start: {
                hours: 23,
                minutes: 0
            },
            end: {
                hours: 23,
                minutes: 59
            },
            isLast: true
        },
        {
            classNumber: "lunch",
            start: {
                hours: 12,
                minutes: 0
            },
            end: {
                hours: 13,
                minutes: 0
            }
        },
        {
            classNumber: "dinner",
            start: {
                hours: 18,
                minutes: 0
            },
            end: {
                hours: 19,
                minutes: 0
            }
        }
    ],
    three: [
        {
            classNumber: "first",
            start: {
                hours: 8,
                minutes: 0
            },
            end: {
                hours: 9,
                minutes: 50
            },
            isFirst: true
        },
        {
            classNumber: "second",
            start: {
                hours: 10,
                minutes: 0
            },
            end: {
                hours: 12,
                minutes: 0
            }
        },
        {
            classNumber: "third",
            start: {
                hours: 13,
                minutes: 0
            },
            end: {
                hours: 14,
                minutes: 50
            }
        },
        {
            classNumber: "fourth",
            start: {
                hours: 15,
                minutes: 0
            },
            end: {
                hours: 16,
                minutes: 50
            }
        },
        {
            classNumber: "fifth",
            start: {
                hours: 17,
                minutes: 0
            },
            end: {
                hours: 18,
                minutes: 0
            }
        },
        {
            classNumber: "sixth",
            start: {
                hours: 19,
                minutes: 0
            },
            end: {
                hours: 20,
                minutes: 50
            }
        },
        {
            classNumber: "seventh",
            start: {
                hours: 21,
                minutes: 0
            },
            end: {
                hours: 21,
                minutes: 50
            },
            isSaturedayLast: true
        },
        {
            classNumber: "eighth",
            start: {
                hours: 22,
                minutes: 0
            },
            end: {
                hours: 23,
                minutes: 59
            },
            isLast: true
        },
        {
            classNumber: "lunch",
            start: {
                hours: 12,
                minutes: 0
            },
            end: {
                hours: 13,
                minutes: 0
            }
        },
        {
            classNumber: "dinner",
            start: {
                hours: 18,
                minutes: 0
            },
            end: {
                hours: 19,
                minutes: 0
            }
        }
    ],
    four: [
        {
            classNumber: "zero",
            start: {
                hours: 7,
                minutes: 30
            },
            end: {
                hours: 8,
                minutes: 40
            }
        },
        {
            classNumber: "first",
            start: {
                hours: 9,
                minutes: 0
            },
            end: {
                hours: 10,
                minutes: 20
            },
            isFirst: true
        },
        {
            classNumber: "second",
            start: {
                hours: 10,
                minutes: 40
            },
            end: {
                hours: 12,
                minutes: 0
            }
        },
        {
            classNumber: "third",
            start: {
                hours: 13,
                minutes: 10
            },
            end: {
                hours: 14,
                minutes: 30
            }
        },
        {
            classNumber: "fourth",
            start: {
                hours: 14,
                minutes: 50
            },
            end: {
                hours: 16,
                minutes: 10
            },
            isSaturedayLast: true
        },
        {
            classNumber: "fifth",
            start: {
                hours: 16,
                minutes: 30
            },
            end: {
                hours: 17,
                minutes: 50
            }
        },
        {
            classNumber: "sixth",
            start: {
                hours: 19,
                minutes: 0
            },
            end: {
                hours: 20,
                minutes: 20
            }
        },
        {
            classNumber: "seventh",
            start: {
                hours: 20,
                minutes: 40
            },
            end: {
                hours: 22,
                minutes: 0
            },
            isLast: true
        },
        {
            classNumber: "eighth",
            start: {
                hours: 22,
                minutes: 0
            },
            end: {
                hours: 24,
                minutes: 0
            }
        },
        {
            classNumber: "lunch",
            start: {
                hours: 12,
                minutes: 0
            },
            end: {
                hours: 13,
                minutes: 10
            }
        },
        {
            classNumber: "dinner",
            start: {
                hours: 17,
                minutes: 50
            },
            end: {
                hours: 19,
                minutes: 0
            }
        }
    ],
    five: [
        {
            classNumber: "first",
            start: {
                hours: 8,
                minutes: 0
            },
            end: {
                hours: 9,
                minutes: 0
            },
            isFirst: true
        },
        {
            classNumber: "second",
            start: {
                hours: 9,
                minutes: 20
            },
            end: {
                hours: 10,
                minutes: 40
            }
        },
        {
            classNumber: "third",
            start: {
                hours: 11,
                minutes: 0
            },
            end: {
                hours: 12,
                minutes: 10
            }
        },
        {
            classNumber: "fourth",
            start: {
                hours: 13,
                minutes: 30
            },
            end: {
                hours: 14,
                minutes: 50
            }
        },
        {
            classNumber: "fifth",
            start: {
                hours: 15,
                minutes: 10
            },
            end: {
                hours: 16,
                minutes: 30
            }
        },
        {
            classNumber: "sixth",
            start: {
                hours: 16,
                minutes: 50
            },
            end: {
                hours: 18,
                minutes: 0
            },
            isSaturedayLast: true
        },
        {
            classNumber: "seventh",
            start: {
                hours: 19,
                minutes: 10
            },
            end: {
                hours: 20,
                minutes: 30
            }
        },
        {
            classNumber: "eighth",
            start: {
                hours: 20,
                minutes: 50
            },
            end: {
                hours: 22,
                minutes: 0
            },
            isLast: true
        },
        {
            classNumber: "lunch",
            start: {
                hours: 12,
                minutes: 10
            },
            end: {
                hours: 13,
                minutes: 30
            }
        },
        {
            classNumber: "dinner",
            start: {
                hours: 18,
                minutes: 0
            },
            end: {
                hours: 19,
                minutes: 10
            }
        }
    ],
    six: [
        {
            classNumber: 'zero',
            start: { hours: 8, minutes: 0 },
            end: { hours: 8, minutes: 20 }
        },
        {
            classNumber: 'first',
            start: { hours: 8, minutes: 30 },
            end: { hours: 10, minutes: 0 }
        },
        {
            classNumber: 'second',
            start: { hours: 10, minutes: 10 },
            end: { hours: 11, minutes: 50 }
        },
        {
            classNumber: 'third',
            start: { hours: 13, minutes: 0 },
            end: { hours: 14, minutes: 20 }
        },
        {
            classNumber: 'fourth',
            start: { hours: 14, minutes: 40 },
            end: { hours: 16, minutes: 10 }
        },
        {
            classNumber: 'fifth',
            start: { hours: 16, minutes: 30 },
            end: { hours: 17, minutes: 50 }
        },

        {
            classNumber: 'sixth',
            start: { hours: 19, minutes: 0 },
            end: { hours: 20, minutes: 20 }
        },
        {
            classNumber: 'seventh',
            start: { hours: 20, minutes: 30 },
            end: { hours: 21, minutes: 50 }
        },
        {
            classNumber: 'eighth',
            start: { hours: 22, minutes: 0 },
            end: { hours: 22, minutes: 50 }
        },
        {
            classNumber: 'lunch',
            start: { hours: 11, minutes: 50 },
            end: { hours: 13, minutes: 0 }
        },
        {
            classNumber: 'dinner',
            start: { hours: 17, minutes: 50 },
            end: { hours: 19, minutes: 0 }
        },
    ],
    seven: [
        {
            classNumber: 'zero',
            start: { hours: 8, minutes: 0 },
            end: { hours: 8, minutes: 20 }
        },
        {
            classNumber: 'first',
            start: { hours: 8, minutes: 30 },
            end: { hours: 9, minutes: 20 }
        },
        {
            classNumber: 'second',
            start: { hours: 9, minutes: 30 },
            end: { hours: 10, minutes: 20 }
        },
        {
            classNumber: 'third',
            start: { hours: 10, minutes: 30 },
            end: { hours: 12, minutes: 10 }
        },

        {
            classNumber: 'fourth',
            start: { hours: 13, minutes: 10 },
            end: { hours: 14, minutes: 30 }
        },
        {
            classNumber: 'fifth',
            start: { hours: 14, minutes: 45 },
            end: { hours: 16, minutes: 15 }
        },
        {
            classNumber: 'sixth',
            start: { hours: 16, minutes: 30 },
            end: { hours: 17, minutes: 30 }
        },

        {
            classNumber: 'seventh',
            start: { hours: 18, minutes: 30 },
            end: { hours: 19, minutes: 50 }
        },
        {
            classNumber: 'eighth',
            start: { hours: 20, minutes: 5 },
            end: { hours: 21, minutes: 30 }
        },
        {
            classNumber: 'ninth',
            start: { hours: 21, minutes: 40 },
            end: { hours: 22, minutes: 40 }
        },
        {
            classNumber: 'tenth',
            start: { hours: 22, minutes: 50 },
            end: { hours: 23, minutes: 30 }
        },
        {
            classNumber: 'lunch',
            start: { hours: 12, minutes: 10 },
            end: { hours: 13, minutes: 10 }
        },
        {
            classNumber: 'dinner',
            start: { hours: 17, minutes: 30 },
            end: { hours: 18, minutes: 30 }
        },
    ],
    eight: [
        {
            classNumber: 'first',
            start: { hours: 8, minutes: 0 },
            end: { hours: 8, minutes: 50 }
        },
        {
            classNumber: 'second',
            start: { hours: 9, minutes: 0 },
            end: { hours: 9, minutes: 50 }
        },
        {
            classNumber: 'third',
            start: { hours: 10, minutes: 0 },
            end: { hours: 10, minutes: 50 }
        },
        {
            classNumber: 'fourth',
            start: { hours: 11, minutes: 0 },
            end: { hours: 11, minutes: 50 }
        },

        {
            classNumber: 'fifth',
            start: { hours: 13, minutes: 0 },
            end: { hours: 13, minutes: 50 }
        },
        {
            classNumber: 'sixth',
            start: { hours: 14, minutes: 0 },
            end: { hours: 14, minutes: 50 }
        },
        {
            classNumber: 'seventh',
            start: { hours: 15, minutes: 0 },
            end: { hours: 15, minutes: 50 }
        },
        {
            classNumber: 'eighth',
            start: { hours: 16, minutes: 0 },
            end: { hours: 17, minutes: 0 }
        },

        {
            classNumber: 'ninth',
            start: { hours: 18, minutes: 0 },
            end: { hours: 18, minutes: 50 }
        },
        {
            classNumber: 'tenth',
            start: { hours: 19, minutes: 0 },
            end: { hours: 19, minutes: 50 }
        },
        {
            classNumber: 'eleventh',
            start: { hours: 20, minutes: 0 },
            end: { hours: 20, minutes: 50 }
        },
        {
            classNumber: 'twelfth',
            start: { hours: 21, minutes: 0 },
            end: { hours: 21, minutes: 50 }
        },
        {
            classNumber: 'thirteenth',
            start: { hours: 22, minutes: 0 },
            end: { hours: 22, minutes: 50 }
        },
        {
            classNumber: 'fourteenth',
            start: { hours: 23, minutes: 0 },
            end: { hours: 23, minutes: 50 }
        },
        {
            classNumber: 'lunch',
            start: { hours: 12, minutes: 0 },
            end: { hours: 13, minutes: 0 }
        },
        {
            classNumber: 'dinner',
            start: { hours: 17, minutes: 0 },
            end: { hours: 18, minutes: 0 }
        },
    ],
    nine : [
        {
          classNumber: 'first',
          start: { hours: 9, minutes: 0 },
          end:   { hours: 9, minutes: 50 },
          isFirst: true
        },
        {
          classNumber: 'second',
          start: { hours: 10, minutes: 0 },
          end:   { hours: 10, minutes: 50 }
        },
        {
          classNumber: 'third',
          start: { hours: 11, minutes: 0 },
          end:   { hours: 11, minutes: 50 }
        },
        {
          classNumber: 'fourth',
          start: { hours: 12, minutes: 0 },
          end:   { hours: 12, minutes: 50 }
        },
        {
          classNumber: 'fifth',
          start: { hours: 13, minutes: 0 },
          end:   { hours: 13, minutes: 50 }
        },
        {
          classNumber: 'sixth',
          start: { hours: 14, minutes: 0 },
          end:   { hours: 14, minutes: 50 }
        },
        {
          classNumber: 'seventh',
          start: { hours: 15, minutes: 0 },
          end:   { hours: 15, minutes: 50 }
        },
        {
          classNumber: 'eighth',
          start: { hours: 16, minutes: 0 },
          end:   { hours: 16, minutes: 50 }
        },
        {
          classNumber: 'ninth',
          start: { hours: 17, minutes: 0 },
          end:   { hours: 17, minutes: 50 }
        },
        {
          classNumber: 'tenth',
          start: { hours: 18, minutes: 0 },
          end:   { hours: 18, minutes: 50 }
        },
        {
          classNumber: 'eleventh',
          start: { hours: 19, minutes: 0 },
          end:   { hours: 19, minutes: 50 }
        },
        {
          classNumber: 'twelfth',
          start: { hours: 20, minutes: 0 },
          end:   { hours: 20, minutes: 50 }
        },
        {
          classNumber: 'thirteenth',
          start: { hours: 21, minutes: 0 },
          end:   { hours: 21, minutes: 50 }
        },
        {
          classNumber: 'fourteenth',
          start: { hours: 22, minutes: 0 },
          end:   { hours: 22, minutes: 50 }
        },
        {
          classNumber: 'fifteenth',
          start: { hours: 23, minutes: 0 },
          end:   { hours: 23, minutes: 50 },
          isLast: true
        }
    ],
    ten : [
        {
          classNumber: 'first',
          start: { hours: 16, minutes: 0 },
          end:   { hours: 16, minutes: 50 },
          isFirst: true
        },
        {
          classNumber: 'second',
          start: { hours: 17, minutes: 0 },
          end:   { hours: 17, minutes: 50 }
        },
        {
          classNumber: 'third',
          start: { hours: 18, minutes: 0 },
          end:   { hours: 18, minutes: 50 }
        },
        {
          classNumber: 'fourth',
          start: { hours: 19, minutes: 0 },
          end:   { hours: 19, minutes: 50 }
        },
        {
          classNumber: 'fifth',
          start: { hours: 20, minutes: 0 },
          end:   { hours: 20, minutes: 50 }
        },
        {
          classNumber: 'sixth',
          start: { hours: 21, minutes: 0 },
          end:   { hours: 21, minutes: 50 }
        },
        {
          classNumber: 'seventh',
          start: { hours: 22, minutes: 0 },
          end:   { hours: 22, minutes: 50 }
        },
        {
          classNumber: 'eighth',
          start: { hours: 23, minutes: 0 },
          end:   { hours: 23, minutes: 50 },
          isLast: true
        }
      ]
}

const totalLocationData: LocationData[] = [
    {
        academy: ["sunbae", "mom", "molip", "alltarget"],
        korean: "전체",
        english: "total",
        filterValue_contains: "",
        jobs: [
            {
                english: "total",
                korean: "전체",
                filterValue_contains: "",
                index: false
            }
        ],
    },
    {
        academy: ["sunbae"],
        korean: "강남점",
        english: "gangnam",
        filterValue_contains: "강남점",
        jobs: [
            {
                english: "desk",
                korean: "강남 데스크",
                filterValue_contains: "강남 데스크",
                index: 0
            },
            {
                english: "coach",
                korean: "강남 사감",
                filterValue_contains: "강남 사감",
                index: 1
            },
        ],
        maxSeat: 75,
        seatSvg: GangnamSeatSvg,
        questionLocation: [
            {
                korean: "강남점",
                english: "gangnam",
            }
        ],
        classInfo: classInfos.one,
        needRegularMeal: true
    },
        {
        academy  : ["sunbae"],
        korean : "강남2호점",
        english : "gangnam2",
        filterValue_contains : "강남2호점",
        jobs : [
            {
                english: "desk14",
                korean: "강남2호점 데스크",
                filterValue_contains: "강남2호점 데스크",
                index: 28
            },
            {
                english: "coach14",
                korean: "강남2호점 사감",
                filterValue_contains: "강남2호점 사감",
                index: 29  
            }
        ],
        maxSeat: 67,
        seatSvg : Gangnam2Seat,
        questionLocation : [
            {
                korean : "강남2호점",
                english : "gangnam2",
            }
        ],
        classInfo : classInfos.one,
        needRegularMeal : true
    },
    {
        academy: ["sunbae"],
        korean: "대치점",
        english: "daechi",
        filterValue_contains: "대치점",
        jobs: [
            {
                english: "desk2",
                korean: "대치 데스크",
                filterValue_contains: "대치 데스크",
                index: 2
            },
            {
                english: "coach2",
                korean: "대치 사감",
                filterValue_contains: "대치 사감",
                index: 3
            },
        ],
        maxSeat: 73,
        seatSvg: DaechiSeatSvg,
        questionLocation: [
            {
                korean: "대치점",
                english: "daechi",
            },
            {
                korean: "대치2,3층",
                english: "daechi_12",
            },
            {
                korean: "대치2,6층",
                english: "daechi_13",
            },
            {
                korean: "대치점 전체",
                english: "daechiTotal",
            }
        ],
        classInfo: classInfos.one,
        needRegularMeal: true
    },
    {
        academy: ["sunbae"],
        korean: "대치3층",
        english: "daechi2",
        filterValue_contains: "대치3층",
        jobs: [
            {
                english: "desk3",
                korean: "대치 3층 데스크",
                filterValue_contains: "대치 3층 데스크",
                index: 4
            },
            {
                english: "coach3",
                korean: "대치 3층 사감",
                filterValue_contains: "대치 3층 사감",
                index: 5
            },
        ],
        maxSeat: 84,
        seatSvg: Daechi2SeatSvg,
        questionLocation: [
            {
                korean: "대치3층",
                english: "daechi2",
            },
            {
                korean: "대치3,6층",
                english: "daechi_23",
            },
            {
                korean: "대치2,3층",
                english: "daechi_12",
            },
            {
                korean: "대치점 전체",
                english: "daechiTotal",
            }
        ],
        classInfo: classInfos.one,
        needRegularMeal: true
    },
    {
        academy: ["sunbae"],
        korean: "대치6층",
        english: "daechi3",
        filterValue_contains: "대치6층",
        jobs: [
            {
                english: "desk4",
                korean: "대치 6층 데스크",
                filterValue_contains: "대치 6층 데스크",
                index: 6
            },
            {
                english: "coach4",
                korean: "대치 6층 사감",
                filterValue_contains: "대치 6층 사감",
                index: 7
            }
        ],
        maxSeat: 73,
        seatSvg: Daechi3SeatSvg,
        questionLocation: [
            {
                korean: "대치6층",
                english: "daechi3",
            },
            {
                korean: "대치3,6층",
                english: "daechi_23",
            },
            {
                korean: "대치2,6층",
                english: "daechi_13",
            },
            {
                korean: "대치점 전체",
                english: "daechiTotal",
            }
        ],
        classInfo: classInfos.one,
        needRegularMeal: true
    },
    {
        academy: ["sunbae"],
        korean: "송파점",
        english: "songpa",
        filterValue_contains: "송파점",
        jobs: [
            {
                english: "desk8",
                korean: "송파 데스크",
                filterValue_contains: "송파 데스크",
                index: 14
            },
            {
                english: "coach8",
                korean: "송파 사감",
                filterValue_contains: "송파 사감",
                index: 15
            }
        ],
        maxSeat: 96,
        seatSvg: SongpaSeatSvg,
        questionLocation: [
            {
                korean: "송파점",
                english: "songpa",
            },
        ],
        classInfo: classInfos.one,
        needRegularMeal : true
    },
    {
        academy: ["mom"],
        korean: "송도_지정석",
        english: "songdo_fixed",
        filterValue_contains: "송도_지정석",
        jobs: [
            {
                english: "desk1",
                korean: "송도 데스크",
                filterValue_contains: "송도 데스크",
                index: 8
            },
            {
                english: "coach1",
                korean: "송도 사감",
                filterValue_contains: "송도 사감",
                index: 9
            }
        ],
        questionLocation: [
            {
                korean: "송도_지정석",
                english: "songdo_fixed",
            },
            {
                korean: "송도_전체",
                english: "songdo_all"
            }
        ],
        classInfo: classInfos.two,
        seatSvg: SongdoFixedSeatSvg
    },
    {
        academy: ["mom"],
        korean: "송도_자유석",
        english: "songdo_free",
        filterValue_contains: "송도_자유석",
        questionLocation: [
            {
                korean: "송도_자유석",
                english: "songdo_free",
            },
            {
                korean: "송도_전체",
                english: "songdo_all"
            }
        ],
        classInfo: classInfos.two,
        seatSvg: SongdoFreeSeatSvg,
        isFree: true
    },
    {
        academy : ["mom"],
        korean : "송도_7층",
        english : "songdo_7th",
        filterValue_contains : "송도_7층",
        questionLocation : [
            {
                korean : "송도_7층",
                english : "songdo_7th", 
            },
            {
                korean : "송도_전체",
                english : "songdo_all"
            },
        ],
        classInfo : classInfos.two,
        seatSvg : Songdo7thSeatSvg,
        jobs : [
            {
                english : "desk15",
                korean : "송도 7층 데스크",
                filterValue_contains : "송도 7층 데스크",
                index : 30
            },
            {
                english : "coach15",
                korean : "송도 7층 사감",
                filterValue_contains : "송도 7층 사감",
                index : 31
            }
        ]
    },
    {
        academy: ["molip"],
        korean: "몰입공간",
        english: "molip",
        filterValue_contains: "몰입공간",
        classInfo: classInfos.four,
        seatSvg: MolipSeatSvg,
        jobs: [
            {
                english: "desk5",
                korean: "몰입 데스크",
                filterValue_contains: "몰입 데스크",
                index: 10
            },
            {
                english: "coach5",
                korean: "몰입 사감",
                filterValue_contains: "몰입 사감",
                index: 11
            }
        ],
        questionLocation: [
            {
                korean: "몰입공간",
                english: "molip",
            }
        ]
    },
    {
        academy: ["sunbae"],
        korean: "분당점",
        english: "bundang",
        filterValue_contains: "분당점",
        classInfo: classInfos.one,
        jobs: [
            {
                english: "desk6",
                korean: "분당 데스크",
                filterValue_contains: "분당 데스크",
                index: 12
            },
            {
                english: "coach6",
                korean: "분당 사감",
                filterValue_contains: "분당 사감",
                index: 13
            }
        ],
        maxSeat: 146,
        seatSvg: BundangSeatSvg,
        questionLocation: [
            {
                korean: "분당점",
                english: "bundang",
            }
        ],
        needRegularMeal: true,
        needOutside : true
    },
    {
        academy: ["sunbae"],
        korean: "대구점",
        english: "daegu",
        filterValue_contains: "대구점",
        classInfo: classInfos.one,
        jobs: [
            {
                english: "desk12",
                korean: "대구 데스크",
                filterValue_contains: "대구 데스크",
                index: 24
            },
            {
                english: "coach12",
                korean: "대구 사감",
                filterValue_contains: "대구 사감",
                index: 25
            }
        ],
        maxSeat: 156,
        seatSvg: DaeguSeatSvg,
        questionLocation: [
            {
                korean: "대구점",
                english: "daegu",
            }
        ],
        needRegularMeal: true,
        needOutside : true
    },
    {
        academy: ["sunbae"],
        korean: "김포점",
        english: "gimpo",
        filterValue_contains: "김포점",
        classInfo: classInfos.one,
        jobs: [
            {
                english: "desk16",
                korean: "김포 데스크",
                filterValue_contains: "김포 데스크",
                index: 32
            },
            {
                english: "coach16",
                korean: "김포 사감",
                filterValue_contains: "김포 사감",
                index: 33
            }
        ],
        maxSeat: 177,
        seatSvg: GimpoSeatSvg,
        questionLocation: [
            {
                korean: "김포점",
                english: "gimpo",
            }
        ],
        needRegularMeal: true,
        needOutside : true
    },
    {
        academy: ["sunbae"],
        korean: "신촌점",
        english: "sinchon",
        filterValue_contains: "신촌점",
        classInfo: classInfos.one,
        jobs: [
            {
                english: "desk17",
                korean: "신촌 데스크",
                filterValue_contains: "신촌 데스크",
                index: 34
            },
            {
                english: "coach17",
                korean: "신촌 사감",
                filterValue_contains: "신촌 사감",
                index: 35
            }
        ],
        maxSeat: 147,
        seatSvg: SinchonSeatSvg2,
        questionLocation: [
            {
                korean: "신촌점",
                english: "sinchon",
            }
        ],
        needRegularMeal: true,
        needOutside : true
    },
    {
        academy: ["sunbae"],
        korean: "강동점",
        english: "gangdong",
        filterValue_contains: "강동점",
        classInfo: classInfos.one,
        jobs: [
            {
                english: "desk18",
                korean: "강동 데스크",
                filterValue_contains: "강동 데스크",
                index: 36
            },
            {
                english: "coach18",
                korean: "강동 사감",
                filterValue_contains: "강동 사감",
                index: 37
            }
        ],
        maxSeat: 154,
        seatSvg: GangdongSeatSvg,
        questionLocation: [
            {
                korean: "강동점",
                english: "gangdong",
            }
        ],
        needRegularMeal: true,
        needOutside : true
    },
    {
        academy: ["sunbae"],
        korean: "하남점",
        english: "hanam",
        filterValue_contains: "하남점",
        classInfo: classInfos.one,
        jobs: [
            {
                english: "desk19",
                korean: "하남 데스크",
                filterValue_contains: "하남 데스크",
                index: 38
            },
            {
                english: "coach19",
                korean: "하남 사감",
                filterValue_contains: "하남 사감",
                index: 39
            }
        ],
        maxSeat: 126,
        seatSvg: HanamSeat,
        questionLocation: [
            {
                korean: "하남점",
                english: "hanam",
            }
        ],
        needRegularMeal: true,
        needOutside : true
    },
    {
        academy: ["ubase"],
        korean: "유베이스",
        english: "ubase",
        filterValue_contains: "유베이스",
        classInfo: classInfos.five,
        jobs: [
            {
                english: "desk7",
                korean: "유베이스 데스크",
                filterValue_contains: "유베이스 데스크",
                index: 16
            },
            {
                english: "coach7",
                korean: "유베이스 사감",
                filterValue_contains: "유베이스 사감",
                index: 17
            }
        ],
        seatSvg: UbaseSeatSvg,
        questionLocation: [
            {
                korean: "유베이스",
                english: "ubase",
            }
        ],
        needRegularMeal: true
    },
    {
        academy : ["alltarget"],
        korean : "GET-A",
        english : "getA",
        filterValue_contains : "GET-A",
        classInfo : classInfos.six,
        jobs : [
            {
                english : "desk9",
                korean : "GET-A 데스크",
                filterValue_contains : "GET-A 데스크",
                index : 18
            },
            {
                english : "coach9",
                korean : "GET-A 사감",
                filterValue_contains : "GET-A 사감",
                index : 19
            }
        ],
        seatSvg : AllTargetSeat2,
        questionLocation : [
            {
                korean : "GET-A",
                english : "getA",
            }
        ],
        needRegularMeal : true
    },
    {
        academy : ["alltarget"],
        korean : "GET-L",
        english : "getL",
        filterValue_contains : "GET-L",
        classInfo : classInfos.seven,
        jobs : [
            {
                english : "desk10",
                korean : "GET-L 데스크",
                filterValue_contains : "GET-L 데스크",
                index : 20
            },
            {
                english : "coach10",
                korean : "GET-L 사감",
                filterValue_contains : "GET-L 사감",
                index : 21
            }
        ],
        seatSvg : AllTargetSeat,
        questionLocation : [
            {
                korean : "GET-L",
                english : "getL",
            }
        ],
        needRegularMeal : true
    },
    {
        academy : ["alltarget"],
        korean : "GET-50",
        english : "get50",
        filterValue_contains : "GET-50",
        classInfo : classInfos.eight,
        jobs : [
            {
                english : "desk11",
                korean : "GET-50 데스크",
                filterValue_contains : "GET-50 데스크",
                index : 22
            },
            {
                english : "coach11",
                korean : "GET-50 사감",
                filterValue_contains : "GET-50 사감",
                index : 23
            }
        ],
        seatSvg : AllTargetSeat2,
        questionLocation : [
            {
                korean : "GET-50",
                english : "get50",
            }
        ],
        needRegularMeal : true
    },
    {
        academy : ["lion"],
        korean : "사자",
        english : "lion",
        filterValue_contains : "사자",
        classInfo : classInfos.nine,
        jobs : [
            {
                english : "desk13",
                korean : "사자 데스크",
                filterValue_contains : "사자 데스크",
                index : 26
            },
            {
                english : "coach13",
                korean : "사자 사감",
                filterValue_contains : "사자 사감",
                index : 27
            }
        ],
        seatSvg : LionSeatSvg,
        questionLocation : [
            {
                korean : "사자",
                english : "lion",
            },
        ],
        needRegularMeal : false
    },
    {
        academy: ["sunbae"],
        korean: "센텀점",
        english: "centum",
        filterValue_contains: "센텀점",
        classInfo: classInfos.one,
        jobs: [
            {
                english: "desk20",
                korean: "센텀 데스크",
                filterValue_contains: "센텀 데스크",
                index: 40
            },
            {
                english: "coach20",
                korean: "센텀 사감",
                filterValue_contains: "센텀 사감",
                index: 41
            }
        ],
        maxSeat: 122,
        seatSvg: CentumSeatSvg,
        questionLocation: [
            {
                korean: "센텀점",
                english: "centum",
            }
        ],
        needRegularMeal: true,
        needOutside : true
    },
    {
        academy: ["sunbae"],
        korean: "동탄점",
        english: "dongtan",
        filterValue_contains: "동탄점",
        classInfo: classInfos.one,
        jobs: [
            {
                english: "desk21",
                korean: "동탄 데스크",
                filterValue_contains: "동탄 데스크",
                index: 42
            },
            {
                english: "coach21",
                korean: "동탄 사감",
                filterValue_contains: "동탄 사감",
                index: 43
            }
        ],
        maxSeat: 108,
        seatSvg: DongtanSeatSvg,
        questionLocation: [
            {
                korean: "동탄점",
                english: "dongtan",
            }
        ],
        needRegularMeal: true,
        needOutside : true
    }
]

export default totalLocationData;